<template>
  <div>
    <el-form-item :label="field.name + '：'" label-width="110px">
      <draggable v-model="config[field.key]">
        <el-row
          class="image-item"
          v-for="(item, index) in config[field.key]"
          :key="index"
          type="flex"
        >
          <el-col class="col-left">
            <choose-photo
              :config="config"
              :field="field"
              :quote="0"
              :imgName="'image_url'"
              :index="index"
            ></choose-photo>
            <p>{{ config[field.key][index]["memo"] }}</p>
          </el-col>
          <el-col class="col-right">
            <div
              v-if="config[field.key][index]['link_name']"
              style="word-break:break-all"
            >
              {{ config[field.key][index]["link_name"] }}:
              {{ config[field.key][index]["link_data"] }}
            </div>
            <el-button
              size="mini"
              @click="openDialog(index)"
              v-text="
                config[field.key][index]['link_name']
                  ? '更换链接'
                  : '请选择链接'
              "
              style="margin-right: 10px;"
            ></el-button>
            <el-button
              v-if="config[field.key][index]['link_name']"
              size="mini"
              class="clear-link"
              @click="clearLink(index)"
              style="margin-left: 0px;"
              >清除链接
            </el-button>
          </el-col>
          <i
            class="el-icon-circle-close-outline"
            @click="removeImageItem(index)"
          ></i>
        </el-row>
      </draggable>
    </el-form-item>

    <!-- 请选择链接 -->
    <el-dialog
      title="请选择链接"
      :visible.sync="dialog.visible"
      @close="closeDialog"
    >
      <helper @select="select" @close="closeDialog"></helper>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.image-item {
  position: relative;
  border: 1px solid #e3e7ee;
  background-color: #f9f9f9;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 20px;
  .col-left {
    flex: 0 0 150px;
  }
  .col-right {
    flex: 1;
    .link-name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100px;
      padding-right: 10px;
    }
  }
  .el-icon-circle-close-outline {
    font-size: 18px;
    position: absolute;
    top: -9px;
    right: -9px;
    background: #fff;
    cursor: pointer;
  }
}
</style>

<script>
import ChoosePhoto from "./choose-photo.vue";
import draggable from "vuedraggable";

export default {
  name: "tms-type-img-link-list",
  props: {
    field: {
      type: [Object, Array],
      required: true,
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      dialog: {
        visible: false,
      },
      linkNameList: {},
      currentIndex: 0,
    };
  },

  components: {
    ChoosePhoto,
    draggable,
  },

  mounted() {
  },

  methods: {
    clearLink(index) {
      delete this.config[this.field.key][index].link_name;
      delete this.config[this.field.key][index].link_data;
      delete this.config[this.field.key][index].link_type;
      let temp = this.config[this.field.key][index];
      this.config[this.field.key].splice(index, 1, temp);
    },
    removeImageItem(index) {
      this.config[this.field.key].splice(index, 1);
    },
    openDialog(index) {
      this.currentIndex = index;
      this.dialog.visible = true;
    },
    closeDialog() {
      this.dialog.visible = false;
    },
    select(link, linkName, linkType) {
      this.config[this.field.key][this.currentIndex].link_name = linkName;
      this.config[this.field.key][this.currentIndex].link_data = link;
      this.config[this.field.key][this.currentIndex].link_type = linkType;
      this.dialog.visible = false;
    },
  },
};
</script>
